"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import PalettePanel from "../ui/overlays/PalettePanel";

//===================================================
//
// Constructor
//
//===================================================

function PaletteButton() {
    PIXI.Container.call(this);


    // Attributes
    this._button = null;
    this._selectionSprite = null;
    this._shineOverlay = null;
    this._type = null;


    // Signals.
    this.signals = {};
    this.signals.onClick = new signals.Signal();
}

export default PaletteButton;
//module.exports = PaletteButton;
PaletteButton.prototype = Object.create(PIXI.Container.prototype);
PaletteButton.prototype.constructor = PaletteButton;


//===================================================
//
// Public
//
//===================================================

PaletteButton.prototype.init = function () {
    // Button.
    var btnStatesAux = new P3.ButtonStates(
        Common.assets.getTexture("icon_colour_palette_bg"),
        Common.assets.getTexture("icon_colour_palette_bg"),
        Common.assets.getTexture("icon_colour_palette_bg"));
    this._button = new P3.Button(btnStatesAux);
    this._button.anchor = new PIXI.Point(0.5, 0.5);
    this._button.signals.click.add(this.signals.onClick.dispatch, this);
    this.addChild(this._button);

    // Selection sprite.
    this._selectionSprite = new PIXI.Sprite(Common.blankTexture);
    this._selectionSprite.x = -60;
    this._selectionSprite.y = 21;
    this._selectionSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._button.addChild(this._selectionSprite);

    this._shineOverlay = new PIXI.Sprite(Common.assets.getTexture("btns_colour_overlay"));
    this._shineOverlay.anchor = new PIXI.Point(0.5, 0.5);
    this._shineOverlay.blendMode = PIXI.BLEND_MODES.ADD;
    this._shineOverlay.alpha = 0.4;
    this._selectionSprite.addChild(this._shineOverlay);
};

PaletteButton.prototype.setup = function (selection, toolType) {
    this._type = toolType;

    this._selectionSprite.tint = 0xffffff;

    switch (this._type) {
        case CommonGame.TOOL.BRUSH:
        case CommonGame.TOOL.PENCIL:
        case CommonGame.TOOL.INK_POT:
        case CommonGame.TOOL.SPRAY:
        case CommonGame.TOOL.BUCKET:
        {
            this._shineOverlay.visible = true;

            this._button._currentNormalTexture = Common.assets.getTexture("icon_colour_palette_bg");
            this._button._currentOverTexture = Common.assets.getTexture("icon_colour_palette_bg");
            this._button._currentDownTexture = Common.assets.getTexture("icon_colour_palette_bg");
            this._button._background.texture = this._button._currentNormalTexture;

            if (selection.indexOf("#") == 0) {
                this._selectionSprite.texture = Common.assets.getTexture("btns_colour_white");
                this._selectionSprite.tint = parseInt("0x" + selection.substring(1));
            }
            else
                this._selectionSprite.texture = Common.assets.getTexture(CommonGame.TEXTURE_BUTTON_BASE_ID + selection.substring(selection.length - 2));

            this._selectionSprite.scale.x = -0.8;
            this._selectionSprite.scale.y = 0.8;

            break;
        }

        case CommonGame.TOOL.STAMP:
        {
            this._shineOverlay.visible = false;

            this._button._currentNormalTexture = Common.assets.getTexture("icon_stamp_palette_bg");
            this._button._currentOverTexture = Common.assets.getTexture("icon_stamp_palette_bg");
            this._button._currentDownTexture = Common.assets.getTexture("icon_stamp_palette_bg");
            this._button._background.texture = this._button._currentNormalTexture;

            this._selectionSprite.texture = Common.assets.getTexture(selection);
            this._selectionSprite.scale.x = -1;
            this._selectionSprite.scale.y = 0.8;

            break;
        }
    }
};

PaletteButton.prototype.setInteractive = function (isInteractive) {
    this._button.interactive = isInteractive;
    this._button.alpha = isInteractive ? 1 : 0.5;
    this._selectionSprite.alpha = this._button.alpha;
};


//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

// TODO:


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    PaletteButton.prototype,
    "type",
    {
        get: function () {
            return this._type;
        }
    });